
<template>
    <div id="Exhibition" class="wrap">
        <div class="exhibition">
            <div class="title">
                <h2>Exhibition</h2>
            </div>  
            <!-- src => image로 대체 artList -->
            <!-- <li v-for="item in artList2" :key="item.th"> 
                <div class="row">
                    <div class="col-12 col-md-7">
                        <img :src="item.image" style="width:65%;" class="ne">
                        <div class="imgbox"><img :src="item.thumbnail"></div>
                    </div>
                    <div class="col-12 col-md-5">
                        <table>
                            <tbody>
                                <tr>
                                    <th><h5>{{item.th}}기</h5></th>
                                    <td>
                                        <h6>{{item.listTitle}}</h6>
                                        <p v-html="item.description" />
                                    </td>
                                </tr>
                                <tr style="font-size:13.5px; white-space: normal;">
                                    <th>참여작가</th>
                                    <td>{{item.author}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </li> -->
            <li v-for="item in artList" :key="item.th">
                <div class="row">
                    <div class="col-12 col-md-7">
                        <iframe :src="`https://www.youtube.com/embed/`+item.src" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        <div class="imgbox"><img :src="item.thumbnail"></div>
                    </div>
                    <div class="col-12 col-md-5">
                        <table>
                            <tbody>
                                <tr>
                                    <th><h5>{{item.th}}기</h5></th>
                                    <td>
                                        <h6>{{item.listTitle}}</h6>
                                        <p v-html="item.description" />
                                    </td>
                                </tr>
                                <tr style="font-size:13.5px; white-space: normal;">
                                    <th>참여작가</th>
                                    <td>{{item.author}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </li>
        </div>
    </div>
</template>

<script>
import { list } from '@/mixins/list.js';

export default {
    mixins:[list],

    data(){
        return{

        }
    },
    methods:{
        exhibition(){ //지난 전시
            console.log(list)
        }
    }
}
</script>


<style lang="scss">
#Exhibition {
    .exhibition{padding-bottom: 80px;
        .title{margin: 90px 0 0 0; }
        li{border-top: 1px solid #acacac; padding: 1.8rem 0 1.8rem;}
        .row{width: 100%;
            .col-12:first-child{padding-left: 0; height: 350px;
                iframe{width: 65%; height: inherit;}
                .imgbox{width: 33%; height: inherit; margin-left: 2%; position: relative;
                    img{width: 100%; height: inherit; object-fit: cover;}
                }
            }
            .col-12{display:flex}
            .col-12:last-child{padding-right: 0;
                table{text-align: left; font-size: 1.08rem;
                    tbody{ 
                        tr{
                            th{vertical-align: top; min-width: 80px; font-weight: 400; height: 95%;
                                h5{font-size: 1.123rem; font-weight: 500;}
                            }
                            td{
                                h6{margin-bottom: 0.5rem; padding: 0; font-weight: 500;}
                                p{font-weight: 300; max-height: 20vh; overflow-y: auto; padding-bottom: 20px;}
                            }
                        }
                    }
                }
            }
        }
    }
}

@media(max-width:767px){
    #Exhibition{
        .exhibition{ padding-bottom: 50px; padding-left: 10px; padding-right: 10px;
             .title{margin: 10px 0 0 10px; 
                h2{margin-bottom: 0;}
            }
            .row{
                .col-12:first-child{padding: 0; margin-bottom: 1rem; height: 24vh;
                    iframe{width: 65%; height: 100%;}
                    img{width: 60%; height: 100%;}
                }
                .imgbox{width: 38%; margin-left: 2%; position: relative;}
                .col-12:last-child{padding: 0;
                    table{font-size: 1rem;}
                    p{font-size: 15px;}
                }
                td{font-size: 12px;}
            }
        }
    }
}

</style>